// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { listUsages, listMetrics } from "./operations.js";
export type {
  CollectionPartitionListUsagesOptionalParams,
  CollectionPartitionListMetricsOptionalParams,
} from "./options.js";
